import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import axiosApiInstance from "app/services/axios";
import { getDataEndPoint, updateDataEndPoint } from "app/utils/constants/paths";
import uuid from "react-uuid";
import { DATASOURCE_CONFIG } from "app/config";
import { addslashes } from "app/utils/utils";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  companiesList: [],
  companyDetails: {
    name: "",
    tag_id: "",
    email: "",
    phone: "",
    address: "",
    bc_email: "",
    cs_email: "",
    po_email: "",
    logoUrl: "",
    theme: "",
    id: "",
    logo_height:''
  },
};

export const GetAllCompainesListThunk = createAsyncThunk(
  "company/GetAllCompainesListThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            payload?.search != "" &&
            payload?.search != undefined &&
            payload?.search != null
              ? "select id,name,tag_id,email,phone,address,logo_url,theme,creation_date from " +
                tablePrefix +
                "companies where name " +
                DATASOURCE_CONFIG.QUERY_LIKE +
                " '%" +
                payload.search +
                "%' and status ='1' order by creation_date desc"
              : "select id,name,tag_id,email,phone,address,logo_url,theme,creation_date from " +
                tablePrefix +
                "companies where status ='1' order by creation_date desc",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const InsertUpdateCompanyDetailsThunk = createAsyncThunk(
  "company/InsertUpdateCompanyDetailsThunk",
  async (payload) => {
    let insertUpdateQuery = "";
    if (payload.action == "add") {
      insertUpdateQuery =
        "insert into " +
        tablePrefix +
        "companies (id,name,tag_id,email,phone,address,supply_dashboard_price_percentage,bc_email,cs_email,po_email,creation_date,updated_date,logo_url,theme,created_by,logo_height) values('" +
        payload.id +
        "','" +
        addslashes(payload.name) +
        "','" +
        payload.tag_id +
        "','" +
        addslashes(payload.email) +
        "','" +
        payload.phone +
        "','" +
        addslashes(payload.address) +
        "','" +
        payload.supply_dashboard_price_percentage +
        "','" +
        addslashes(payload.bc_email) +
        "','" +
        addslashes(payload.cs_email) +
        "','" +
        addslashes(payload.po_email) +
        "'," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ",'" +
        payload.logoUrl +
        "','" +
        payload.theme +
        "','" +
        payload.created_by +
        "','" +
        payload.logo_height +
        "') ";
    } else {
      insertUpdateQuery =
        "update " +
        tablePrefix +
        "companies set name='" +
        addslashes(payload.name) +
        "',tag_id='" +
        payload.tag_id +
        "',email='" +
        addslashes(payload.email) +
        "',phone='" +
        payload.phone +
        "',address='" +
        addslashes(payload.address) +
        "',supply_dashboard_price_percentage='" +
        (payload.supply_dashboard_price_percentage) +
        "',bc_email='" +
        addslashes(payload.bc_email) +
        "',cs_email='" +
        addslashes(payload.cs_email) +
        "',po_email='" +
        addslashes(payload.po_email) +
        "',logo_url='" +
        payload.logoUrl +
        "',theme='" +
        payload.theme +
        "',logo_height='" +
        payload.logo_height +
        "',updated_date=" +
        DATASOURCE_CONFIG.CURRENT_DATE +
        " where id='" +
        payload.id +
        "'";
    }
    console.log("insertUpdateQuery", insertUpdateQuery);
    const queryBody = {
      queries: [
        {
          query: insertUpdateQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetCompaniesDetailsThunk = createAsyncThunk(
  "company/GetCompaniesDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select id,name,tag_id,email,phone,address,supply_dashboard_price_percentage,bc_email,cs_email,po_email,logo_url,theme,logo_height from " +
            tablePrefix +
            "companies where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const UpdateCompanyStatusThunk = createAsyncThunk(
  "company/UpdateCompanyStatusThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "companies set status='0' where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const Company = createSlice({
  name: "company",
  initialState,
  reducers: {
    resetCompanyForm(state, action) {
      state.companyDetails = {
        name: "",
        tag_id: "",
        email: "",
        phone: "",
        address: "",
        supply_dashboard_price_percentage: "",
        bc_email: "",
        cs_email: "",
        po_email: "",
        logoUrl: "",
        theme: "",
        id: "",
        logo_height:''
      };
    },
  },

  extraReducers(builder) {
    builder
      .addCase(GetAllCompainesListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllCompainesListThunk.fulfilled, (state, action) => {
        if (action.payload.data.results[0]) {
          state.companiesList = action.payload.data.results[0];
        }
        // if (action.payload.data.status === 1) {
        // } else if (action.payload.data.status == 0) {
        //     // toast.error(action.payload.data.message);
        // }
        // if (state.globalAccountsList.length > 0) {
        //     state.globalAccount = state.globalAccountsList[0].value;
        //     console.log("state.globalAccount", state.globalAccount);
        // }
        state.loading = false;
      })
      .addCase(GetAllCompainesListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(InsertUpdateCompanyDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(InsertUpdateCompanyDetailsThunk.fulfilled, (state, action) => {
        if (!action.payload.data?.error) {
          let companyData = {
            name: action.meta.arg.name,
            tag_id: action.meta.arg.tag_id,
            email: action.meta.arg.email,
            phone: action.meta.arg.phone,
            address: action.meta.arg.address,
            supply_dashboard_price_percentage:
              action.meta.arg.supply_dashboard_price_percentage,
            bc_email: action.meta.arg.bc_email,
            cs_email: action.meta.arg.cs_email,
            po_email: action.meta.arg.po_email,
            logoUrl: action.meta.arg.logoUrl,
            theme: action.meta.arg.theme,
            id: action.meta.arg.id,
            logo_height:action.meta.arg.logo_height
          };
          state.companyDetails = companyData;
        }
        state.loading = false;
      })
      .addCase(InsertUpdateCompanyDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })

      .addCase(GetCompaniesDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetCompaniesDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results[0].length > 0) {
          let resultData = action.payload.data?.results[0][0];
          let companyData = {
            name: resultData.name,
            tag_id: resultData.tag_id,
            email: resultData.email,
            phone: resultData.phone,
            address: resultData.address,
            supply_dashboard_price_percentage:
              resultData.supply_dashboard_price_percentage,
            bc_email: resultData.bc_email,
            cs_email: resultData.cs_email,
            po_email: resultData.po_email,
            logoUrl: resultData.logo_url,
            theme: resultData.theme,
            id: resultData.id,
            logo_height:resultData.logo_height
          };
          state.companyDetails = companyData;
        }
        state.loading = false;
      })
      .addCase(GetCompaniesDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(UpdateCompanyStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateCompanyStatusThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          let companyList = state.companiesList;
          let companyId = action.meta.arg.id;
          companyList = companyList.filter((item) => item.id !== companyId);
          state.companiesList = companyList;
        }
        state.loading = false;
      })
      .addCase(UpdateCompanyStatusThunk.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
const { actions, reducer } = Company;
// Extract and export each action creator by name
export const {
  resetCompanyForm,
  // showHideSwitchAccountModal,
  // switchToAccount,
  // updateDashboardFilter,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
